import gql from 'graphql-tag';

export const IntegrationsDiscoveryInstalledApps = gql`
	query IntegrationsDiscoveryInstalledApps($appKeys: [String!]) @experimental {
		experimentalIntegrationsInstalled(appKeys: $appKeys) {
			isSlackEnabled
			isSlackConnected
			integrations {
				appKey
				isInstalled
			}
		}
	}
`;
